var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.Qtxzgl_detailed_add),
      expression: "Qtxzgl_detailed_add"
    }]
  }, [_c('div', {
    staticStyle: {
      "font-size": "20px",
      "float": "left",
      "margin": "-40px 0 0 40px",
      "font-weight": "600"
    }
  }, [_vm._v("其他险种管理-明细-" + _vm._s(_vm.ruleForm.id != null && _vm.ruleForm.id != '' ? '修改' : '新增'))]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "float": "right",
      "height": "40px",
      "margin-top": "-40px",
      "margin-right": "40px",
      "background-color": "#006E4B",
      "color": "#FFFFFF",
      "border": "1px solid #006E4B"
    },
    on: {
      "click": _vm.Return
    }
  }, [_vm._v("返回")]), _vm._v(" "), _c('div', {
    staticStyle: {
      "height": "540px",
      "background-color": "white",
      "margin": "75px 40px 0 40px",
      "padding": "100px",
      "overflow-x": "hidden"
    }
  }, [_vm._l((_vm.ruleForm.insuranceList), function(item, index) {
    return _c('div', {
      key: index
    }, [_c('span', {
      staticStyle: {
        "color": "#006E4B",
        "font-weight": "900",
        "font-size": "20px"
      }
    }, [_vm._v("|   ")]), _vm._v(" "), _c('span', {
      staticStyle: {
        "font-size": "20px",
        "font-weight": "700"
      }
    }, [_vm._v("明细" + _vm._s(index + 1))]), _vm._v(" "), _c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index != 0),
        expression: "index != 0"
      }],
      staticStyle: {
        "float": "right",
        "margin-right": "20px"
      },
      attrs: {
        "src": require("../../../assets/icon/减少.png"),
        "width": "25px"
      },
      on: {
        "click": function($event) {
          return _vm.delTtinerary(index)
        }
      }
    }), _vm._v(" "), _c('div', {
      staticStyle: {
        "border": "1px solid #DADADA",
        "margin-top": "10px"
      }
    }), _vm._v(" "), _c('el-form', {
      ref: "ruleForm",
      refInFor: true,
      staticClass: "demo-ruleForm",
      attrs: {
        "model": _vm.ruleForm,
        "rules": _vm.rules,
        "label-width": "180px"
      }
    }, [_c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-top": "40px",
        "width": "80%"
      },
      attrs: {
        "label": "保单名称",
        "prop": "insurance_name"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.$parent.ruleForm.insurance_name),
        callback: function($$v) {
          _vm.$set(_vm.$parent.ruleForm, "insurance_name", $$v)
        },
        expression: "$parent.ruleForm.insurance_name"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "margin-top": "40px",
        "width": "80%"
      },
      attrs: {
        "label": "保单号",
        "prop": "policy_no"
      }
    }, [_c('el-input', {
      attrs: {
        "disabled": true
      },
      model: {
        value: (_vm.$parent.ruleForm.policy_no),
        callback: function($$v) {
          _vm.$set(_vm.$parent.ruleForm, "policy_no", $$v)
        },
        expression: "$parent.ruleForm.policy_no"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "所属项目",
        "prop": "organize_temporary_ids"
      }
    }, [_c('el-cascader', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "collapse-tags": "",
        "props": _vm.props,
        "show-all-levels": false
      },
      on: {
        "change": _vm.changeCascader
      },
      model: {
        value: (_vm.insuranceList[index].organize_temporary_ids),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "organize_temporary_ids", $$v)
        },
        expression: "insuranceList[index].organize_temporary_ids"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "唯一识别码",
        "prop": "unique_id"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入唯一识别码"
      },
      model: {
        value: (_vm.insuranceList[index].unique_id),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "unique_id", $$v)
        },
        expression: "insuranceList[index].unique_id"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "投保数量",
        "prop": "insure_number"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入投保数量"
      },
      model: {
        value: (_vm.insuranceList[index].insure_number),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "insure_number", $$v)
        },
        expression: "insuranceList[index].insure_number"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "名称/品牌",
        "prop": "brand"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入名称/品牌"
      },
      model: {
        value: (_vm.insuranceList[index].brand),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "brand", $$v)
        },
        expression: "insuranceList[index].brand"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "规格/型号",
        "prop": "model"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入规格/型号"
      },
      model: {
        value: (_vm.insuranceList[index].model),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "model", $$v)
        },
        expression: "insuranceList[index].model"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "费用金额",
        "prop": "cost"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入费用金额"
      },
      model: {
        value: (_vm.insuranceList[index].cost),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "cost", $$v)
        },
        expression: "insuranceList[index].cost"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "生效时间",
        "required": ""
      }
    }, [_c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "start_date"
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "type": "date",
        "placeholder": "请选择",
        "value-format": "yyyy-MM-dd"
      },
      model: {
        value: (_vm.insuranceList[index].start_date),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "start_date", $$v)
        },
        expression: "insuranceList[index].start_date"
      }
    })], 1)], 1), _vm._v(" "), _c('el-col', {
      staticClass: "line",
      attrs: {
        "span": 1
      }
    }, [_vm._v(" - ")]), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 9
      }
    }, [_c('el-form-item', {
      attrs: {
        "prop": "end_date"
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "85%"
      },
      attrs: {
        "type": "date",
        "placeholder": "请选择",
        "value-format": "yyyy-MM-dd"
      },
      model: {
        value: (_vm.insuranceList[index].end_date),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "end_date", $$v)
        },
        expression: "insuranceList[index].end_date"
      }
    })], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "付款时间",
        "prop": "payment_date"
      }
    }, [_c('el-date-picker', {
      staticStyle: {
        "width": "73%"
      },
      attrs: {
        "type": "datetime",
        "value-format": "yyyy-MM-dd HH:mm:ss",
        "placeholder": "请选择付款时间"
      },
      model: {
        value: (_vm.insuranceList[index].payment_date),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "payment_date", $$v)
        },
        expression: "insuranceList[index].payment_date"
      }
    })], 1)], 1)], 1), _vm._v(" "), _c('el-form-item', {
      staticStyle: {
        "width": "90%"
      },
      attrs: {
        "label": "备注",
        "prop": "remarks"
      }
    }, [_c('el-input', {
      attrs: {
        "placeholder": "请输入备注"
      },
      model: {
        value: (_vm.insuranceList[index].remarks),
        callback: function($$v) {
          _vm.$set(_vm.insuranceList[index], "remarks", $$v)
        },
        expression: "insuranceList[index].remarks"
      }
    })], 1), _vm._v(" "), _c('el-row', [_c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      attrs: {
        "label": "批改扫描件",
        "prop": "copy_url"
      }
    }, [_c('el-upload', {
      attrs: {
        "action": _vm.$globals.http + 'file/upload',
        "list-type": "picture-card",
        "on-preview": _vm.handlePictureCardPreview,
        "limit": 1,
        "on-remove": _vm.handleRemove,
        "file-list": _vm.insuranceList[index].copy_url,
        "on-success": _vm.handleAvatarSuccess
      }
    }, [_c('i', {
      staticClass: "el-icon-plus"
    })]), _vm._v(" "), _c('el-dialog', {
      attrs: {
        "visible": _vm.dialogVisible
      },
      on: {
        "update:visible": function($event) {
          _vm.dialogVisible = $event
        }
      }
    }, [_c('img', {
      attrs: {
        "width": "100%",
        "src": _vm.insuranceList[index].copy_url,
        "alt": ""
      }
    })])], 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 12
      }
    }, [_c('el-form-item', {
      staticStyle: {
        "width": "80%"
      },
      attrs: {
        "label": "上传附件",
        "prop": "enclosure_url"
      }
    }, [_c('el-upload', {
      staticClass: "upload-demo",
      attrs: {
        "action": _vm.$globals.http + '/file/upload',
        "on-preview": _vm.handlePreview,
        "on-remove": _vm.handleRemove,
        "on-success": _vm.uploadFujian,
        "before-remove": _vm.beforeRemove,
        "multiple": "",
        "on-exceed": _vm.handleExceed,
        "file-list": _vm.insuranceList[index].enclosure_url,
        "v-model": _vm.insuranceList[index].enclosure_url
      }
    }, [_c('el-button', {
      staticStyle: {
        "font-size": "10px",
        "width": "100px"
      },
      attrs: {
        "type": "goon"
      }
    }, [_vm._v("上传附件")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
      staticStyle: {
        "margin-left": "5%"
      }
    }, [_c('img', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (index === (_vm.ruleForm.insuranceList.length - 1) && (_vm.ruleForm.id == null || _vm.ruleForm.id == '')),
        expression: "index === (ruleForm.insuranceList.length - 1) && (ruleForm.id == null || ruleForm.id == '')"
      }],
      attrs: {
        "src": require("../../../assets/icon/添加明细.png")
      },
      on: {
        "click": _vm.AddTtinerary
      }
    })])], 1)], 1)
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "margin-left": "45%",
      "margin-top": "50px"
    }
  }, [_c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id == null || _vm.ruleForm.id == ''),
      expression: "ruleForm.id == null || ruleForm.id == ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm()
      }
    }
  }, [_vm._v("保存")]), _vm._v(" "), _c('el-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.ruleForm.id != null && _vm.ruleForm.id != ''),
      expression: "ruleForm.id != null && ruleForm.id != ''"
    }],
    attrs: {
      "type": "goon"
    },
    on: {
      "click": function($event) {
        return _vm.Update()
      }
    }
  }, [_vm._v("修改")])], 1)], 2)], 1)])
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c12adc4e","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/bxgl/QtxzGl/Qtxzgl_detailed_add.vue
// module id = null
// module chunks = 